// Source/Actions/mod.ts
var Action_Key = "Action";
var url = new URL(location.href);
var search = url.searchParams;
var action = search.get(Action_Key);
search.delete(Action_Key);
history.replaceState(history.state, "", url.href);
if (action)
  runAction(action);
function runAction(type) {
  switch (type) {
    case "Open-Cart":
      const event = new CustomEvent("Cart:Drawer:Open");
      document.dispatchEvent(event);
  }
}
